export enum LocalStorageKeys {
  user = 'user'
}
